/**
 * Created by iamso on 05.08.19.
 */

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    TREASURE_SEARCH_TIMER_TEXT: {
        name: "default",
        size: 40,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    }
});

cleverapps.styles.TreasureSearchWindow = {
    delay: 16,

    content: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: 20 }
    },

    timer: {
        width: 250,

        positions: [{
            x: { align: "center", dx: -75 }, y: { align: "bottom", dy: 180 }
        }, {
            x: { align: "center", dx: 0 }, y: { align: "bottom", dy: -35 }
        }, {
            x: { align: "center", dx: 0 }, y: { align: "bottom", dy: -35 }
        }]
    }
};
